import CheckboxSelectAll from "@stimulus-components/checkbox-select-all"

export default class extends CheckboxSelectAll {
  static targets = ["checkbox", "checkboxAll", "actionButton"]

  connect() {
    super.connect()
    this.updateButtonVisibility()

    // Ensure every checkbox triggers the update function
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.addEventListener(
        "change",
        this.updateButtonVisibility.bind(this)
      )
    })
  }

  toggle(event) {
    super.toggle(event)
    this.updateButtonVisibility()
  }

  toggleAll(event) {
    super.toggleAll(event)
    this.updateButtonVisibility()
  }

  updateButtonVisibility = () => {
    const checkedCount = this.checkboxTargets.filter(
      (checkbox) => checkbox.checked
    ).length

    // Show the action button only if at least two checkboxes are selected
    if (this.hasActionButtonTarget) {
      this.actionButtonTarget.classList.toggle("hidden", checkedCount < 2)
    }
  }
}
